import React, { useEffect, useState } from "react";
import ActionsFullScreenEnterNormalXsmall from "@strava/icons/ActionsFullScreenEnterNormalXsmall";
import ActionsFullScreenExitNormalXsmall from "@strava/icons/ActionsFullScreenExitNormalXsmall";
import { Button } from "@strava/ui/Button";

import I18n from "../../../utils/I18n";

import styles from "./FullscreenToggle.scss";

export const FullscreenToggle = () => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  // Effect to handle adding/removing fullscreen class on body
  // This is required for the active based solution only and will need
  // to be reworked as part of the modernization effort.
  useEffect(() => {
    // Safari specific classname is used to replicate existing behaviour
    // Note: This may not be necessary for modern fullscreen implementations
    // and should be reconsidered during modernization
    const isSafari =
      /safari/.test(navigator.userAgent.toLowerCase()) &&
      !/chrome/.test(navigator.userAgent.toLowerCase());

    const className = isSafari ? "fauxscreen" : "fullscreen";

    if (isFullscreen) {
      document.body.classList.add(className);
    } else {
      document.body.classList.remove(className);
    }
  }, [isFullscreen]);

  // Effect to handle browser fullscreenchange event (triggered within coffeescript code)
  useEffect(() => {
    // Add event listener for fullscreen changes
    document.addEventListener("fullscreenchange", handleFullscreenChange);

    // Cleanup event listener when component unmounts
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);

  const handleFullscreenClick = () => {
    const toggleFullscreenEvent = new CustomEvent("toggleFullscreen");
    document.dispatchEvent(toggleFullscreenEvent);

    setIsFullscreen(prevIsFullscreen => !prevIsFullscreen);
  };

  // Handler for fullscreen change event
  // Updates the isFullscreen state based on the current browser fullscreen element status
  const handleFullscreenChange = () => {
    setIsFullscreen(
      document.fullscreenElement ||
        (document as any).webkitFullscreenElement ||
        (document as any).mozFullScreenElement
    );
  };

  return (
    <Button
      className={styles.fullscreenButton}
      data-testid="fullscreen-toggle-button"
      title={I18n.t(
        isFullscreen
          ? "mre.custom_control.exit_fullscreen_mode"
          : "mre.custom_control.enter_fullscreen_mode"
      )}
      onClick={handleFullscreenClick}
    >
      {isFullscreen ? (
        <ActionsFullScreenExitNormalXsmall data-testid="exit-fullscreen-icon" />
      ) : (
        <ActionsFullScreenEnterNormalXsmall data-testid="enter-fullscreen-icon" />
      )}
    </Button>
  );
};

export default FullscreenToggle;
